import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';
import ModalStore from '../../../../../Modal/Store';
import PreviewStore from './Store';
import { isInEditMode } from './Store/Types';

interface Props {
  store: PreviewStore;
  leaveEditModeModalStore: ModalStore;
}

const Header: React.FC<Props> = ({ store, leaveEditModeModalStore }) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-center py-5',
        'md:flex-row',
        store.inEditMode ? 'bg-teal-200' : '',
      )}
    >
      <h2 className="text-lg font-semibold">
        <T kind="Learning Collection Preview for Participants" />
      </h2>
      {when(isInEditMode, store)
        .map(() => (
          <Button
            type="button"
            value="Leave Edit Mode"
            onClick={store.leaveEditMode}
            disabled={store.learningCollectionStore.inPreviewUpdatingState}
            intercomTarget="builder-leave-edit-mode-button"
            className={clsx(
              'ml-2.5 rounded border border-teal-600 text-teal-600',
              'bg-white px-5 py-2.5 text-sm font-semibold',
            )}
          />
        ))
        .getOrElse(() => (
          <Button
            type="button"
            value="Edit Participant View"
            intercomTarget="builder-edit-participant-view-button"
            onClick={store.enterEditMode}
            className="ml-2.5 rounded bg-teal-600  px-5 py-2.5 text-sm font-semibold text-white"
          />
        ))}
    </div>
  );
};

export default observer(Header);
